<div>
  <mat-toolbar color="primary" class="flex-direction-row">
    <button mat-stroked-button class="nav-button" routerLink="/login">
      Sign in
    </button>
  </mat-toolbar>

  <div class="container">
    <h1 class="text-center" i18n="@@signed-out">You have been signed out.</h1>
    <span i18n="@@signed-out-text"
      >You can log back in any time you'd like</span
    >
    <img
      src="../../../assets/img/MMLogo.png"
      width="500vw"
      height="300vh"
      alt="MediaMarkt logo"
    />
    <button
      mat-raised-button
      color="primary"
      routerLink="/login"
      i18n="@@sign-in"
    >
      Sign me back in
    </button>
  </div>
</div>
